import { SectionLabel } from "@/features/simulations/sandbox/results/result-primitives";
import type { InterpretationFacts } from "@/types/interpretation.types";

// Gargalo + (quando aplicável) causa da diferença (comparação) e leitura do lote. Cada bloco só
// aparece quando há dado — sem inventar seções vazias.

export function DetailSections({
  facts,
}: {
  facts: InterpretationFacts;
}): React.ReactElement | null {
  const { bottleneck, comparison, batch } = facts;
  if (!bottleneck && !comparison && !batch) return null;
  return (
    <>
      {bottleneck ? (
        <section>
          <SectionLabel>Gargalo</SectionLabel>
          <p className="text-[13px] text-text-secondary">
            {bottleneck.machineNames.join(", ") || "—"}
            {bottleneck.throughputUnH != null ? (
              <span className="text-muted-foreground">
                {" "}
                · {bottleneck.throughputUnH.toLocaleString("pt-BR")} un/h
              </span>
            ) : null}
          </p>
          {bottleneck.shifted ? (
            <p className="mt-1 text-[12px] text-amber-600">
              O gargalo mudou em relação à referência.
            </p>
          ) : null}
        </section>
      ) : null}

      {comparison ? (
        <section>
          <SectionLabel>Causa provável da diferença</SectionLabel>
          <ul className="space-y-1 text-[12.5px] text-text-secondary">
            <li>
              Janela de calibração: <b>{comparison.calibrationDaysA ?? "—"}</b> vs{" "}
              <b>{comparison.calibrationDaysB ?? "—"}</b> dias
            </li>
            {comparison.structureChanged === true ? <li>Estrutura da linha alterada.</li> : null}
            {comparison.paramDiffs.length > 0 ? (
              <li>{comparison.paramDiffs.length} parâmetro(s) de máquina alterado(s).</li>
            ) : null}
          </ul>
        </section>
      ) : null}

      {batch ? (
        <section>
          <SectionLabel>Busca automática</SectionLabel>
          <p className="text-[13px] text-text-secondary">
            {batch.winner ? (
              <>
                Vencedor: <b>{batch.winner.label}</b>
                {batch.winner.meetsTarget != null ? (
                  <span
                    className={
                      batch.winner.meetsTarget ? "text-emerald-700" : "text-muted-foreground"
                    }
                  >
                    {" "}
                    · {batch.winner.meetsTarget ? "meta atingida" : "não atinge a meta"}
                  </span>
                ) : null}
              </>
            ) : (
              "Nenhum candidato superou a configuração atual."
            )}
            <span className="text-muted-foreground"> · {batch.evaluatedCount} avaliados</span>
          </p>
        </section>
      ) : null}
    </>
  );
}
